// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
import * as _facilityContextSignalModule from "@livingsyncs/ui";

export function setFacilityContextSignal(value: string | null) {
  return _facilityContextSignalModule.setFacilityContextSignal(value);
}
export function getFacilityContextSignal() {
  return _facilityContextSignalModule.getFacilityContextSignal();
}
export function __resetFacilityContextSignalForTests() {
  return _facilityContextSignalModule.__resetFacilityContextSignalForTests();
}
